import { combineReducers } from "redux";
import homeReducer from "./common";
export const rootReducer = combineReducers({
    homeReducer

});


 